import { FanguardApiContractsJobJobDetailModel } from 'src/api/generated';

import { get } from '@/api/api';
import { useQuery } from '@tanstack/react-query';

const URI = 'jobs';

const useGetJob = (jobId: string | undefined, enabled: boolean = true) => {
  return useQuery({
    queryKey: [URI, jobId],
    queryFn: async () => {
      if (!jobId) {
        return;
      }
      const response = await get<FanguardApiContractsJobJobDetailModel>({ uri: `${URI}/${jobId}` });

      return response.data;
    },
    enabled: !!jobId && enabled,
    refetchInterval: (data) => {
      const completed = data.state.data?.complete;
      if (completed || !enabled) {
        return false;
      }
      return 1500;
    },
  });
};

const useGetJobOnce = (jobId: string | undefined) => {
  return useQuery({
    queryKey: [URI, jobId, 'once'],
    queryFn: async () => {
      if (!jobId) {
        return;
      }
      const response = await get<FanguardApiContractsJobJobDetailModel>({ uri: `${URI}/${jobId}` });

      return response.data;
    },
    enabled: !!jobId,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: Infinity,
  });
};

export { useGetJob, useGetJobOnce };
